export const paths = {
  home: "/",
  studio: "/studio",
};
